import React from 'react';
import UserInfoMenu from './userInfoMenu';
import styles from '../styles/userInfo.module.scss';
import { Redirect, Route, useRouteMatch } from 'react-router';
import { Switch } from 'react-router-dom';
import { Routes } from './routes';
import UserGeneralInfo from './userGeneralInfo';
import Statistics from './statistics';
import { MAIN_ROUTES } from '@base/features/routing/constants/mainRoutes';
import TournamentStatistics from './tournamentStatistics';
import FeeStatistics from './feeStatistics';
import AccountStatement from './accountStatement';
import GameHistory from './gameHistory';

const UserInfo = () => {
  const { path } = useRouteMatch();

  return (
    <div className={styles.page}>
      <UserInfoMenu />
      <main>
        <Switch>
          <Route exact path={path + '/' + Routes.INFO}>
            <UserGeneralInfo />
          </Route>
          <Route exact path={path + '/' + Routes.STATISTICS}>
            <Statistics />
          </Route>
          <Route exact path={path + '/' + Routes.COMPLETED_TOURNAMENTS}>
            <TournamentStatistics />
          </Route>
          <Route exact path={path + '/' + Routes.FEE_STATISTICS}>
            <FeeStatistics />
          </Route>
          <Route exact path={path + '/' + Routes.ACCOUNT_STATEMENT}>
            <AccountStatement />
          </Route>
          <Route exact path={path + '/' + Routes.GAME_HISTORY}>
            <GameHistory />
          </Route>
          <Redirect from={MAIN_ROUTES.userInfo} to={path + '/' + Routes.INFO} />
        </Switch>
      </main>
    </div>
  );
};

export default UserInfo;
